import { Flex } from "@fluentui/react-northstar";
import { FieldDescriptors } from "@shopify/react-form-state";
import { SurveyLimits } from "@teams/cards";
import {
  NominalQuestion,
  OpenEndedQuestion,
  OrdinalQuestion,
  Question,
  QuestionType,
} from "@teams/types";
import { QuestionTemplateDTO } from "@teams/types/api";
import React from "react";

import { TextAreaField } from "../../../_shared/components/fields/TextAreaField";
import { QuestionSettings } from "../../../_shared/types";
import { NominalQuestionEditor } from "./QuestionEdit/NominalQuestionEditor";
import { OpenEndedQuestionEditor } from "./QuestionEdit/OpenEndedQuestionEditor";
import { OrdinalQuestionEditor } from "./QuestionEdit/OrdinalQuestionEditor";

type PollyQuestionEditProps = {
  questionSettings: QuestionSettings;
  field: FieldDescriptors<Question<QuestionType>>;
  templates: QuestionTemplateDTO[];
  onTemplateSelected: (template: QuestionTemplateDTO) => void;
  originalChoices?: string[];
  isLimitedEdit?: boolean;
  originalAllowedMultipleChoices?: boolean;
  setCollapsed?: (collapsed: boolean) => void;
};

export const PollyQuestionEdit: React.FC<PollyQuestionEditProps> = ({
  questionSettings,
  field,
  originalChoices = [],
  isLimitedEdit,
  originalAllowedMultipleChoices,
  setCollapsed,
}) => {
  return (
    <Flex column gap="gap.medium">
      <TextAreaField
        field={field.label}
        label="Enter question"
        placeholder="Enter your question"
        fluid
        required
        maxLength={SurveyLimits.Questions.Label.MaxLength}
        labelProps={{ weight: "regular" }}
        rows={1}
        autoExpandHeight
      />
      <div>
        {field.questionType.value === "nominal" && (
          <NominalQuestionEditor
            questionSettings={questionSettings}
            field={field as FieldDescriptors<NominalQuestion>}
            isLimitedEdit={isLimitedEdit}
            originalChoices={originalChoices}
            originalAllowedMultipleChoices={originalAllowedMultipleChoices}
            setCollapsed={setCollapsed}
          />
        )}
        {field.questionType.value === "open-ended" && (
          <OpenEndedQuestionEditor
            settings={questionSettings}
            fields={field as FieldDescriptors<OpenEndedQuestion>}
            isLimitedEdit={isLimitedEdit}
            setCollapsed={setCollapsed}
          />
        )}
        {field.questionType.value === "ordinal" && (
          <OrdinalQuestionEditor
            field={field as FieldDescriptors<OrdinalQuestion>}
            questionSettings={questionSettings}
            isLimitedEdit={isLimitedEdit}
            originalChoices={originalChoices}
            setCollapsed={setCollapsed}
          />
        )}
      </div>
    </Flex>
  );
};
